import type {Middleware} from '@linx-security/api-specs';

const controller = new AbortController();
export const getAbortInFlightMiddleware = (abortController: AbortController = controller): Middleware => {
  return {
    pre: async context => {
      if (typeof window !== `undefined`) {
        window.onbeforeunload = function () {
          abortController.abort();
        };
      }
      context.init.signal = abortController.signal;
      return context;
    },
  };
};
